export const Heading = {
  baseStyle: {
    fontWeight: 600,
    marginBottom: { base: 4, lg: 8 },
  },
}
